import React from 'react';
import Spinner from 'react-spinner';

import CountryAssistanceOECD from '../CountryAssistance/CountryAssistanceOECD';
import CountryAssistanceOECDTable from '../CountryAssistance/CountryAssistanceOECDTable';
import { DonorCountrySelect, RecipientCountrySelect } from '../Selects';

class AssistanceLandingProvidedOECD extends CountryAssistanceOECD {
  constructor(props){
    super(props);

    this.state = {
      donor: null,
      recipient: null,
      data: [],
      isLoading: false
    };

    this.handleDonorSelect = this.handleDonorSelect.bind(this);
    this.handleRecipientSelect = this.handleRecipientSelect.bind(this);
    this.onLoading = this.onLoading.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const countryCode = this.state.donor || this.state.recipient,
      oldCountryCode = prevState.donor || prevState.recipient;

    if (countryCode !== oldCountryCode) {
      this.fetchData(
        countryCode,
        this.onLoading
      );
    }
  }

  onLoading(isLoading) {
    this.setState({ isLoading });
  }

  handleRecipientSelect(selected) {
    this.setState({
      donor: null,
      recipient: selected.value
    });
  }

  handleDonorSelect(selected) {
    this.setState({
      donor: selected.value,
      recipient: null
    });
  }

  renderContent() {
    let content;

    if (this.state.isLoading) {
      content = (
        <div className="assistance-page-panel__spinner">
          <Spinner />
        </div>
      );
    } else {
      let type;

      if (this.state.donor) {
        type = 'provided';
      } else if (this.state.recipient) {
        type = 'received';
      }

      const data = this.state.data[type];

      if (data && data.length > 0) {
        content = (
          <CountryAssistanceOECDTable
            data={ data }
            type={ type }
          />
        );
      } else if (type) {
        content = (
          <div className="no-needs-message"  style={{ display: 'block' }}>
            No assistance { type } reported
          </div>
        );
      }
    }

    return content;
  }

  render() {
    return (
      <div className="container-fluid">
        <p>
         Please select a Donor or Recipient
        </p>
        <div className="row">
          <div className="col-md-3">
            <h5>Recipient country</h5>
            <RecipientCountrySelect
              className='assistance-oecd-select'
              value={ this.state.recipient }
              onSelect={ this.handleRecipientSelect }
            />
          </div>

          <div className="col-md-3">
            <h5>Donor country</h5>
            <DonorCountrySelect
              className='assistance-oecd-select'
              value={ this.state.donor }
              onSelect={ this.handleDonorSelect }
            />
          </div>
        </div>

        { this.renderContent() }
      </div>
    )
  }
}

export default AssistanceLandingProvidedOECD;



// WEBPACK FOOTER //
// ./src/components/AssistanceLanding/AssistanceLandingProvidedOECD.js